import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CUISINE_TYPES, SPECIALTIES, cuisineLabel } from "@/utils/cuisines";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/* Sélection contrôlée : types de cuisine (1 à 3 max) + spécialités (plusieurs).
   Aucune saisie libre — valeurs normalisées (évite BBQ/Barbecue/Grill/Grillades). */
export function CuisineModal({ open, onClose, cuisines, specialties, onToggleCuisine, onToggleSpecialty, onDone }) {
  const { t, i18n } = useTranslation();
  const [q, setQ] = useState("");
  const norm = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const match = (c) => !q.trim() || norm(cuisineLabel(c.v, "fr")).includes(norm(q)) || norm(cuisineLabel(c.v, "en")).includes(norm(q));
  const maxed = (cuisines || []).length >= 3;
  const sections = [
    { key: "cuisine", title: t("becomePartner.groupCuisines"), hint: t("becomePartner.cuisineMax3"),
      items: CUISINE_TYPES.filter(match), selected: cuisines || [], toggle: onToggleCuisine,
      disabled: (v) => maxed && !(cuisines || []).includes(v) },
    { key: "specialty", title: t("becomePartner.groupSpecialties"), hint: t("becomePartner.specialtiesHint"),
      items: SPECIALTIES.filter(match), selected: specialties || [], toggle: onToggleSpecialty,
      disabled: () => false },
  ];
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t("becomePartner.allCuisines")}</DialogTitle>
        </DialogHeader>
        <input
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={"🔍 " + t("becomePartner.searchCuisine")}
          data-testid="cuisine-search"
          className="w-full bg-white border border-sand rounded-xl px-4 py-3 outline-none focus:border-brand-red"
        />
        {sections.map((s) => (
          s.items.length > 0 && (
            <div key={s.key}>
              <div className="text-xs uppercase tracking-widest text-mute">{s.title}</div>
              <div className="text-[11px] text-mute mb-2">{s.hint}</div>
              <div className="flex flex-wrap gap-2">
                {s.items.map((c) => {
                  const active = s.selected.includes(c.v);
                  const off = !active && s.disabled(c.v);
                  return (
                    <button
                      key={`${s.key}-${c.v}`}
                      type="button"
                      disabled={off}
                      aria-pressed={active}
                      onClick={() => s.toggle(c.v)}
                      data-testid={`cuisine-opt-${s.key}-${c.v}`}
                      className={`rounded-full px-4 py-2 text-sm font-semibold border transition-colors ${active ? "bg-ink text-white border-ink" : off ? "bg-white border-sand opacity-40 cursor-not-allowed" : "bg-white border-sand hover:border-brand-red"}`}
                    >
                      {cuisineLabel(c.v, i18n.language)}
                    </button>
                  );
                })}
              </div>
            </div>
          )
        ))}
        <button type="button" onClick={() => (onDone ? onDone() : onClose())} data-testid="cuisine-modal-done" className="w-full rounded-full bg-ink text-white py-3 font-semibold">
          OK
        </button>
      </DialogContent>
    </Dialog>
  );
}
